import { search } from "../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/rpa/v1`;

const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export function sendRpa(empresa_cnpj, cpfCnpj, forget = true) {
  return search(
    `${path}/enviarpa?empresa_cnpj=${empresa_cnpj}&forget=${forget}&cpfcnpj=${cpfCnpj}`,
    "GET",
    headers
  );
}
